import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../actions/lister-actions';
import Image from '../Generic/Image/Image';

export const ImageContainer = ({ src, alt = '', url, Code }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const dispatch = useDispatch();

	if (!src) {
		return null;
	}

	if (url) {
		return (
			<a
				className={classnames('pb-1 pr-1', {
					'w-1/3 sm:w-1/4 md:w-1/3 lg:w-1/4 xl:w-1/5': !CustomCategoriesEnabled,
				})}
				href={url}
				onClick={(event) => {
					event.preventDefault();
					window.location.assign(url);

					dispatch(listerClickThrough(Code));
				}}
				itemProp="url"
				data-testid="product-card-link">
				<Image
					src={src}
					alt={alt}
					classes={CustomCategoriesEnabled ? 'w-auto' : 'w-full'}
					style={{
						maxWidth: '300px',
						maxHeight: CustomCategoriesEnabled ? '2.5rem' : '3rem',
					}}
					skeletonProps={{ height: CustomCategoriesEnabled ? '40px' : '48px' }}
					errorSize="small"
				/>
			</a>
		);
	}

	return (
		<Image
			src={src}
			alt={alt}
			classes={classnames('pb-1 pr-1', {
				'w-1/3 sm:w-1/4 md:w-1/3 lg:w-1/4 xl:w-1/5': !CustomCategoriesEnabled,
			})}
			style={{
				maxWidth: '300px',
				maxHeight: CustomCategoriesEnabled ? '2.5rem' : '3rem',
			}}
			skeletonProps={{ height: CustomCategoriesEnabled ? '40px' : '48px' }}
			errorSize="small"
		/>
	);
};

const PromoFlag = ({
	Promotions: { AdvertisablePromotions },
	FullProductUrl,
	Code,
}) => {
	if (!AdvertisablePromotions || AdvertisablePromotions?.length <= 0) {
		return null;
	}

	const singlePromo = AdvertisablePromotions.length === 1;

	return (
		<div
			className={classnames('my-2', {
				'flex items-center': !singlePromo,
			})}>
			{AdvertisablePromotions.slice(0, 3).map(
				({ Url, PathUrl, ImageName, AltText }) => (
					<ImageContainer
						classes="w-full"
						style={{ maxWidth: '300px' }}
						src={singlePromo ? Url : `${PathUrl}small_${ImageName}`}
						alt={AltText}
						url={FullProductUrl}
						Code={Code}
						key={ImageName}
					/>
				)
			)}
		</div>
	);
};

export default PromoFlag;
